import type { NetStatus } from '../net/NetClient'

/**
 * Tiny on-screen connection indicator: green "conectado" (auto-hides),
 * yellow "reconectando…", red "desconectado". Driven by NetClient.onStatus.
 */
export default class ConnectionStatus {
  private readonly el = document.getElementById('net-status')
  private hideTimer?: number

  public set(status: NetStatus): void {
    const el = this.el
    if (!el) return
    if (this.hideTimer !== undefined) {
      window.clearTimeout(this.hideTimer)
      this.hideTimer = undefined
    }
    el.classList.remove(
      'net-status--connected',
      'net-status--reconnecting',
      'net-status--disconnected',
    )
    el.classList.remove('hidden')

    switch (status) {
      case 'connected':
        el.textContent = '● conectado'
        el.classList.add('net-status--connected')
        // Don't keep a green badge on screen — flash it, then fade out.
        this.hideTimer = window.setTimeout(() => el.classList.add('hidden'), 1600)
        break
      case 'reconnecting':
        el.textContent = '● reconectando…'
        el.classList.add('net-status--reconnecting')
        break
      case 'disconnected':
        el.textContent = '● desconectado'
        el.classList.add('net-status--disconnected')
        break
      default:
        el.textContent = '● conectando…'
    }
  }
}
